// extracted by mini-css-extract-plugin
export default {"back":"EntityUploadHeader_back__A61U8"};